import axios from "axios";

export default class PointHttpClientService {
  constructor({
    // root = null,
    baseUrl = null,
    requestInterceptorFn = null,
    cancelToken = null
  }) {
    // this.root = root;
    this.baseUrl = baseUrl;
    this.requestInterceptorFn = requestInterceptorFn;
    this.cancelToken = cancelToken;
  }

  async get({route, params = null, headers = null, successCallback = null, errorCallback = null} = {}) {
    
    var request = axios.create({
      baseURL: this.baseUrl,
      params: params,
      headers: {
        Accept: "application/json",
        ...headers
      },
      timeout: window.appsettings.AppGlobal.ApiTimeOut,
      signal: this.cancelToken?.signal
    });
    
    if (this.requestInterceptorFn != null) {
      // request.interceptors.request.use(requestInterceptorFn, (error) => { console.log(error) });
      request.interceptors.request.use(async (config) => {
        // config.cancelToken = this.cancelToken
        // config.signal = this.cancelToken.signal;
        await this.requestInterceptorFn();

        return config;
      }, (error) => { 
        console.log(error);
        return Promise.reject(error);
       });
    }
    
    var response = null;

    try {
      response = await request.get(route);

      if (successCallback) {
        successCallback(response);
      }

    } catch (error) {
      console.log("error", error);      
      if (errorCallback) {
        errorCallback(error);
      }
      response = error.response ?? error;
      response.ResponseMessage = error?.response?.data?.ResponseStatus?.Message 
          || error?.response?.data?.Message 
          || error?.response?.data?.ErrorMessages?.[0];
      response.ResponseErrorCode = error?.response?.data?.ResponseStatus?.ErrorCode 
          || error?.response?.data?.Message;
    }

    return response;
  }

  async post({route, data = null, params = null, headers = null, successCallback = null, errorCallback = null } = {}) {
    
    
    var request = axios.create({
      baseURL: this.baseUrl,
      params: params || {},
      headers: headers || {},
      timeout: window.appsettings.AppGlobal.ApiTimeOut,
      signal: this.cancelToken?.signal
    });
    
    
    if (this.requestInterceptorFn != null) {
      // request.interceptors.request.use(requestInterceptorFn, (error) => { console.log(error) });
      request.interceptors.request.use(async (config) => {
        // config.cancelToken = this.cancelToken;

        await this.requestInterceptorFn();

        return config;
      }, (error) => { 
        console.log(error);
        return Promise.reject(error);
       });
    }

    try {
      var response = await request.post(route, data);
        
        if (successCallback) {
          successCallback(response);
        }
    } catch (error) {

      if (errorCallback) {
        errorCallback(error);
      }
      response = error.response ?? error;
      response.ResponseMessage = error?.response?.data?.ResponseStatus?.Message 
          || error?.response?.data?.Message 
          || error?.response?.data?.ErrorMessages?.[0];
      response.ResponseErrorCode = error?.response?.data?.ResponseStatus?.ErrorCode 
          || error?.response?.data?.Message;    
    }

    return response;
  }

  async put({route, data = null, params = null, headers = null, successCallback = null, errorCallback = null } = {}) {
    
    var request = axios.create({
      baseURL: this.baseUrl,
      params: params || {},
      headers: headers || {},
      timeout: window.appsettings.AppGlobal.ApiTimeOut,
      signal: this.cancelToken?.signal
    });
    
    
    if (this.requestInterceptorFn != null) {
      request.interceptors.request.use(async (config) => {
        // config.cancelToken = this.cancelToken;

        await this.requestInterceptorFn();

        return config;
      }, (error) => { 
        console.log(error);
        return Promise.reject(error);
       });
    }

    try {
      var response = await request.put(route, data);
        
        if (successCallback) {
          successCallback(response);
        }
    } catch (error) {

      if (errorCallback) {
        errorCallback(error);
        response = error;
        response.ResponseMessage = error?.response?.data?.ResponseStatus?.Message,
        response.ResponseErrorCode = error?.response?.data?.ResponseStatus?.ErrorCode
      }    
    }

    return response;
  }

  async delete({route, params = null, headers = null, successCallback = null, errorCallback = null } = {}){
    var request = axios.create({
      baseURL: this.baseUrl,
      params: params || {},
      headers: headers || {},
      timeout: window.appsettings.AppGlobal.ApiTimeOut,
      signal: this.cancelToken?.signal
    });
    
    
    if (this.requestInterceptorFn != null) {
      request.interceptors.request.use(async (config) => {
        // config.cancelToken = this.cancelToken;

        await this.requestInterceptorFn();

        return config;
      }, (error) => { 
        console.log(error);
        return Promise.reject(error);
       });
    }

    try {
      var response = await request.delete(route);
        
        if (successCallback) {
          successCallback(response);
        }
    } catch (error) {

      if (errorCallback) {
        errorCallback(error);
        response = error;
        response.ResponseMessage = error?.response?.data?.ResponseStatus?.Message,
        response.ResponseErrorCode = error?.response?.data?.ResponseStatus?.ErrorCode
      }    
    }

    return response;
  }

}